module.exports = __webpack_public_path__ + "static/cool-1f8516eaf5f2ae2e4cf15a67f1a56e53.jpg";